import { Navigate } from "react-router-dom";
import { useAppSelector } from "@app/hooks";
import { NavItems } from "@helpers/navigation";
import { getUserRoles } from "@helpers/userPermissionHelper";
import { BasicProps } from "./ComponentsInterface";
import { isEmpty } from "lodash";

export const AuthenticatedRoute = ({
    children,
    roles,
    unauthorizePath = "",
    autoRedirect = true
}: UseUserPermissionProps): JSX.Element => {
    const { userDetail, currentLocation } = useAppSelector((x) => {
        return { userDetail: x.userDetail, currentLocation: x.orgLocations.currentLocation };
    });

    const orgId = userDetail.locations.find((x) => x.id === currentLocation?.id)?.organizationId;
    const organization = userDetail.organizations.find((x) => x.id === orgId) ?? userDetail.organizations[0];
    const userRoles = getUserRoles(userDetail, organization?.roles, currentLocation?.id);
    const hasAccess = userRoles.some((x) => roles.includes(x));

    if (hasAccess) {
        return <>{children}</>;
    }

    return autoRedirect ? (
        <Navigate to={isEmpty(unauthorizePath) ? NavItems.NotAccess.Landing.path : unauthorizePath} />
    ) : (
        <h1>Unauthorized</h1>
    );
};

interface UseUserPermissionProps extends BasicProps {
    roles: number[];
    unauthorizePath?: string;
    autoRedirect?: boolean;
}
